import CircleIcon from "@mui/icons-material/Circle";
import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import dayjs from "dayjs";
import ProfileViewer from "../../../../../../components/ProfileViewer";
import Text from "../../../../../../components/Text";
import { DATE_FORMAT } from "../../../../../../utils/date-time-utility";

const PRESCRIPTION_POLICIES = [
  {
    text: "Please do not wait until your last pill to call for a refill. There is a 72 hour turn around for prescription refills. If you have not seen the Physician in six months, the prescription will be Denied.",
  },
];

interface PatientPrescriptionPolicyProps {
  values: any;
}

const PatientPrescriptionPolicy = ({
  values,
}: PatientPrescriptionPolicyProps) => {
  // Format date
  const formatDate = (date: any) => {
    if (!date) return "";
    try {
      return dayjs(date).format(DATE_FORMAT);
    } catch {
      return "";
    }
  };

  // Prepare pharmacy data for ProfileViewer
  const pharmacyData: { [key: string]: string } = {
    "Pharmacy Name": values.pharmacyName || "",
    "Pharmacy Phone Number": values.pharmacyPhone || "",
    "Signature Date": formatDate(values.signatureDate),
  };

  return (
    <Box mt={1} id={"Prescription Policy"}>
      <Text mb={2}>PRESCRIPTION POLICY</Text>

      {/* Pharmacy Information */}
      <Box mb={2}>
        <ProfileViewer
          data={pharmacyData}
          withoutColn
          firstColW={3}
          secondColW={9}
        />
      </Box>

      {/* Policy List */}
      <List
        sx={{
          "& .MuiListItem-root": {
            alignItems: "flex-start",
            gap: 1,
          },
          "& .MuiListItemIcon-root": {
            minWidth: "auto",
            mt: 1,
            "& .MuiSvgIcon-root": {
              fontSize: "8px",
            },
          },
        }}
      >
        {PRESCRIPTION_POLICIES.map((policy, index) => (
          <ListItem key={index} sx={{ py: 0 }}>
            <ListItemIcon>
              <CircleIcon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Text variant="body2" color="textPrimary">
                  {policy.text}
                </Text>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Signature Section - Always show if signature exists */}
      {values.intakePrescriptionPolicySign && (
        <Box mt={2}>
          <Text mb={1} fontWeight="medium">
            Signature
          </Text>
          <img
            src={values.intakePrescriptionPolicySign}
            alt="Prescription Policy Signature"
            style={{
              height: "150px",
              width: "580px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default PatientPrescriptionPolicy;
